.app {
  position: relative;
  min-height: 100dvh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--color-bg);
}

/* — mobile header — */

.appHeader {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 6px 14px 10px;
  flex: none;
}

.brandName {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: -0.01em;
}

.startOver {
  margin-left: auto;
  font-size: 13px;
}

/* — desktop source bar — */

.sourceBar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  flex: none;
  background: #1b1d2b;
  box-shadow: 0 1px 0 rgb(233 233 237 / 0.08);
}

.brand {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-right: 6px;
}

.urlForm {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.urlForm > input {
  flex: 1;
  max-width: 520px;
  min-height: 36px;
}

.urlForm > button {
  min-height: 36px;
  padding-inline: 16px;
  flex: none;
}

.uploadLabel {
  position: relative;
  min-height: 36px;
  cursor: pointer;
  flex: none;
}

.uploadLabel > input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

/* — layout — */

.main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.stageWell {
  flex: none;
  display: flex;
}

.panel {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 13px 14px 30px;
  background: #1b1d2b;
  box-shadow: 0 -1px 0 rgb(233 233 237 / 0.08);
}

.panelError {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--color-accent-300);
  background: var(--color-accent-800);
  padding: 7px 10px;
  border-radius: 6px;
}

@media (min-width: 900px) {
  .main {
    flex-direction: row;
  }

  .stageWell {
    flex: 1;
    min-width: 0;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #13151f;
    overflow: hidden;
  }

  .panel {
    flex: none;
    width: 312px;
    padding: 20px;
    box-shadow: -1px 0 0 rgb(233 233 237 / 0.08);
    display: flex;
    flex-direction: column;
  }
}
